import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppServiceService } from '../../api/app-service.service';

@Component({
  selector: 'app-open-hours',
  templateUrl: './open-hours.page.html',
  styleUrls: ['./open-hours.page.scss'],
})
export class OpenHoursPage implements OnInit {

  // the restaurant id will pass into this when open hours open from web app
  @Input() restaurantId = null;

  public openHoursData: any[] = [];
  days = {
    MON: 'Monday',
    SUN: 'Sunday',
    TUE: 'Tuesday',
    WED: 'Wensday',
    THU: 'Thursday',
    FRI: 'Friday',
    SAT: 'Saturday',
    SPECIAL: 'Special'
  }

  constructor(public appService: AppServiceService, private route: ActivatedRoute) { }

  ngOnInit() {
    // if ((this.route.snapshot && this.route.snapshot.params['restaurant_id']) || this.restaurantId) {
    //   let restaurantId = this.restaurantId ? this.restaurantId : this.route.snapshot.params['restaurant_id'];
    //   if (!this.restaurantId) this.appService.appObject.isLoading = true;
  }

  ngAfterViewInit() {
    this.getOpenHours();
  }

  async getOpenHours() {
    if ((this.route.snapshot && this.route.snapshot.params['restaurant_id']) || this.restaurantId) {
      let restaurantId = this.restaurantId ? this.restaurantId : this.route.snapshot.params['restaurant_id'];

      // set a timeout to prevent throwing ExpressionChangedAfterItHasBeenCheckedError while showing loading in web version
      setTimeout(() => this.appService.appObject.isLoading = true, 100);

      this.appService.getRestaurantOpeningHours(restaurantId).then((response: any) => {
        // console.log('Response : ', response);
        if (response && response.status && response.data && response.data.openDetails) {
          setTimeout(() => {
            this.openHoursData = response.data.openDetails.filter((detail) => detail.status === 'true');
          }, 100);
        }
        this.appService.appObject.isLoading = false;
      }).catch((error) => {
        console.log('Error : ', error);
        this.appService.appObject.isLoading = false;
      });
      // this.openHoursData = this.appService.appObject.selectedRestaurantDetails.openHoursData.filter((day) => day.status === 'true');
    }
  }

}
